import './Overlay.css'

const Overlay = () => {
  return (
    <div className="overlay"></div>
  )
}

export default Overlay
